import { useEffect } from "react";
import WelcomeSection from "./WelcomeSection";
import DashboardSection from "./DashboardSection";
import AffiliateSection from "./AffiliateSection";
import VideoSection from "./VideoSection";
import FooterSection from "./FooterSection";
const HomeScreen = () => {
  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "/js/main.js";
  //   script.async = true;
  //   document.body.appendChild(script);
  // }, []);
  return (
    <>
      <main>
        <WelcomeSection />
        <DashboardSection />
        <AffiliateSection />
        <VideoSection />
      </main>
      <FooterSection />
    </>
  );
};

export default HomeScreen;
